import { useState } from "react";
import { X, Loader2 } from "lucide-react";
import { CLOSE_REASONS, CLOSE_REASON_LABELS } from "./growthConstants";

// Modal de motivo de cierre — se abre siempre que una tarjeta se mueve a CLOSED (drag o
// selector del drawer), sección 29 del spec. Si el motivo es CUSTOMER, el backend marca
// customer=true/customerAt automáticamente (ver _auto_date_sets en growth.py) — aquí solo se
// manda el closeReason vía PATCH antes de mover la columna.
export default function GrowthCloseModal({ onClose, onConfirm, busy }) {
  const [reason, setReason] = useState("CUSTOMER");

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-2xl">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-base font-bold text-slate-900">Motivo de cierre</h3>
          <button onClick={onClose} className="rounded-lg p-1 text-slate-400 hover:bg-slate-100"><X size={16} /></button>
        </div>
        <div className="space-y-1.5">
          {CLOSE_REASONS.map((r) => (
            <label key={r}
              className={`flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-sm ${reason === r ? "border-red-400 bg-red-50 font-semibold text-red-700" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}>
              <input type="radio" name="growth-close-reason" className="accent-red-600"
                checked={reason === r} onChange={() => setReason(r)} />
              {CLOSE_REASON_LABELS[r]}
            </label>
          ))}
        </div>
        <button onClick={() => onConfirm(reason)} disabled={busy} data-testid="growth-close-confirm"
          className="mt-4 flex w-full items-center justify-center gap-1.5 rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-60">
          {busy && <Loader2 size={14} className="animate-spin" />} Confirmar cierre
        </button>
      </div>
    </div>
  );
}
